import { useLayoutEffect, useMemo } from 'preact/hooks';
import {
  useSceneLoaderContext,
  useCheckoutStore,
  useSelector,
} from '@primer-io/shared-library/contexts';
import { formatVaultedToken } from '../../checkout/formatVaultedToken';
import PaymentMethodTokenItem from '../../components/PaymentMethodTokenItem';
import { Scene } from '../../enums/Checkout';

import { useSceneMounting } from '../../utils/hooks';

const SCENE = Scene.SUCCESS_PAYMENT_METHOD;

const PaymentMethodSuccessScene = () => {
  const store = useCheckoutStore();
  const { setIsMounted } = useSceneLoaderContext();
  const currentToken = useSelector((s) => s.currentToken);

  const item = useMemo(() => {
    if (!currentToken) {
      return null;
    }

    return formatVaultedToken(currentToken);
  }, [currentToken]);

  useLayoutEffect(() => {
    setIsMounted();
  }, []);

  useSceneMounting(() => {
    store.setSubmitButtonVisible(false);
  }, SCENE);

  return (
    <div
      id='primer-checkout-scene-success-payment-method'
      class='PrimerCheckout__scene PrimerCheckout--exited'
      style={{
        padding: '0px 16px',
      }}
    >
      {item && <PaymentMethodTokenItem vaultedItem={item} disabled selected />}
    </div>
  );
};

export default PaymentMethodSuccessScene;
